import { datasetManagePermissions } from './constants';

const canManageDataset = (permissions) => Object.values(datasetManagePermissions).some((key) => permissions[key]);

export default canManageDataset;
